/*
 * コンテンツの座標を取得する
 */
export class ElementPosition {
	static getY(selector) {
		let y = document.querySelector(selector).getBoundingClientRect().top + window.scrollY;
		return y;
	}
}
